import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const nav = document.querySelector('.page-navigation');
  if (!nav) return;

  const hasAdminBar = document.body.classList.contains('admin-bar');
  const triggerOffset = hasAdminBar ? 43 + 32 : 43;

  let navHeight = nav.offsetHeight;

  function onScroll() {
    const navRect = nav.getBoundingClientRect();

    if (navRect.top <= triggerOffset) {
      nav.style.minHeight = navHeight + 'px';
      nav.classList.add('is-fixed');
    } else {
      nav.classList.remove('is-fixed');
      nav.style.minHeight = '';
      navHeight = nav.offsetHeight;
    }
  }

  window.addEventListener('scroll', onScroll);
});
